
import { Component, TemplateRef, ViewChild, effect, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
//import { Toast, ToastService } from '../../services/toast.service';
import { AppToastService } from '../../../../features/widgets/services/app-toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgbToastModule],
  templateUrl: './toast-container.component.html'
})
export class ToastContainerComponent {
  toastService = inject(AppToastService); //our toast service

  constructor() {
  }
}
